import React from 'react';

const focuses = [
  '3D volumetric reconstruction for XR (3DFR pipeline)',
  'Custom Vulkan rendering engine — CodeVkEngine',
  'Hardware ray tracing and BVH acceleration structures',
];

const About: React.FC = () => (
  <section id="about" data-topic="gpu">
    <div className="content">

      <h2 className="section-heading">About</h2>

      <p className="prose">
        Graphics programming sits at the intersection of math, physics simulation,
        and hardware — three domains where imprecision compounds fast. I'm drawn
        to that constraint: when a shader runs millions of times a frame,
        correctness and performance aren't trade-offs, they're the same problem.
      </p>

      <p className="prose">
        Most of my work lives at the API boundary — Vulkan, HLSL, engine internals
        — close enough to the metal to reason about what the GPU scheduler is
        actually doing. I build tools and visualizers alongside production work
        because the fastest way to understand a system is to instrument it.
      </p>

      <p className="prose" style={{ marginBottom: '1.5rem' }}>
        I care less about claiming depth and more about making it inspectable:
        repositories, diagrams, measured results, and concrete rendering systems
        work that can be evaluated directly.
      </p>

      <div style={{ fontSize: '11px', color: 'var(--fg-3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
        Currently focused on
      </div>

      <div className="entry-points">
        {focuses.map((f, i) => (
          <div key={i} className="entry-point">{f}</div>
        ))}
      </div>

      <hr className="hr" style={{ margin: '1.75rem 0' }} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', fontSize: '13px' }}>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <span style={{ color: 'var(--fg-3)', minWidth: '76px' }}>Experience</span>
          <span style={{ color: 'var(--fg-2)' }}>Focused on graphics, GPU, and engine work since 2022 across independent systems projects and professional rendering work since March 2025</span>
        </div>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <span style={{ color: 'var(--fg-3)', minWidth: '76px' }}>Location</span>
          <span style={{ color: 'var(--fg-2)' }}>Ontario, Canada</span>
        </div>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          <span style={{ color: 'var(--fg-3)', minWidth: '76px' }}>Languages</span>
          <span style={{ color: 'var(--fg-2)' }}>Spanish (native) · English (professional)</span>
        </div>
      </div>

    </div>
  </section>
);

export default About;
